<div *ngIf="gifts.length"
     id="listOfGiftsScrollToId"
     class="container-xl mb-5 mt-5">
  <div class="row mb-5">
    <div class="col-12">
      <div class="text-center">
        <h2 [innerHTML]="'GIFTS.LIST.HEADER' | translate"></h2>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-6"
         *ngFor="let gift of gifts">
      <app-gifts-list-item [gift]="gift"
                           class=" mb-5"></app-gifts-list-item>
    </div>
  </div>
  <div *ngIf="!allGiftsShown"
       class="d-flex justify-content-center">
    <button type="button"
            class="btn btn-primary btn-lg px-5"
            (click)="showAllGifts()"
            [translate]="'GIFTS.LIST.BUTTON-SHOW-ALL'">
    </button>
  </div>
</div>
